import { Suspense } from 'react';
import './App.css';
import LaunchingSoon from './components/LaunchingSoon';
import PatentContextProvider from './context/PatentContextProvider';
import Pillar from './components/FivePillar';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";


function App() {
  return (
    <div>
      <PatentContextProvider>
        <Router>
          <Routes>
            <Route path='/' element={<Suspense fallback={<div className="h-screen bg-white">Loading...</div>}> <LaunchingSoon /></Suspense>} />
            <Route path='/seven-pillars' element={<Suspense fallback={<div className="h-screen bg-white">Loading...</div>}> <Pillar /></Suspense>} />
          </Routes>
        </Router>
      </PatentContextProvider>
    </div>
  );
}

export default App;
